import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
//import VueTrumbowyg from 'vue-trumbowyg';
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import routes from './routes';
//import moment from 'moment';

import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import VueToastr from "vue-toastr";
import readableName from './mixins/readableName';
import './assets/styles/custom_checkbox.css';

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VueSidebarMenu);
Vue.use(VueQuillEditor)
Vue.use(VueToastr, {
  defaultProgressBar: false,
  defaultTimeout: 3000,
  defaultClassNames: ["animated", "zoomInUp"],
  defaultStyle:{
    opacity: 1
  }
});

const router = new VueRouter(
  {
    routes,
    mode: 'history'
  }
);

let getCookie = (name) => {
  let value = "; " + document.cookie;
  let parts = value.split("; " + name + "=");
  if ( parts.length == 2 ) {
    return parts.pop().split(";").shift();
  }
}

// This function middleware is called before every route change

router.beforeEach((to, from, next) => {
 
  if ( !getCookie('xsrf_token') && to.path !== '/login' && from.path !== '/login' ) {
    alert('Your last login session has expired, so you will now be redirected back to the login screen. Please log in again.');
    next("/login");
  } else if (to.meta.requireAuth) {
    const roles = JSON.parse(localStorage.getItem('roles'));
    const tables = JSON.parse(localStorage.getItem('tables'));
    
    if (to.path.includes('data_correction') && !roles.includes('data_correction') && !roles.includes('admin')){
       next("/home");
    }
    if (!roles.includes('reader') && !roles.includes('writer') && !roles.includes('admin')) {
     
      if (!to.params.table && !(to.fullPath).includes('multiTable')) {
        next("/home");
      }
      const targetTable = tables.find(t => t.name === to.params.table);
      
      if (!targetTable && !(to.fullPath).includes('multiTable')) {
        next("/home");
      } else if (targetTable && roles.length == 1 && roles.includes('contact_information_contractor') && !targetTable.name.includes('research_worksheet')){
          next("/home");
      } else if (to.path.includes('add') && !targetTable.permissions.includes('INSERT')) {
        next("/home");
      }
     }
  }
  if (to.params && to.params.table) {
    document.title = (to.path.includes('add') ? 'Adding to ' : 'Editing ') + readableName.methods.readableName(to.params.table);
  } else if (to.params && to.params.name) {
    document.title =  readableName.methods.readableName(to.params.name)
  } else {
    document.title = 'Ballotpedia API4';
  }
  next();
  
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
